export { default } from "./routes/index.tsx";